var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',[_vm._v(_vm._s(_vm.value.format('YYYY')))]),_c('div',{staticClass:"weekRow"}),_c('footer')])
}
var staticRenderFns = []

export { render, staticRenderFns }